import { useColorMode } from "components/core/colorModeContent"
import { Link } from "components/core/link"
import { Badge } from "components/core/badge"
import { UserAvatar } from "components/layout/header/userMenu"
import { Dashboard, PublicDashboardUser } from "domainModels/dashboard"
import { getDashboardSlug, getScreenshot, rgbDataURL } from "lib/utils"
import Image from "next/image"
import { FC } from "react"
import { Card } from "./core/card"

interface Props {
  dashboard: Dashboard
  publicDashboardUser?: PublicDashboardUser
}

export const ExploreItem: FC<Props> = ({ dashboard, publicDashboardUser }) => {
  const { darkModeEnabled } = useColorMode()
  const slug = getDashboardSlug(dashboard.id!, dashboard.user_id)
  const screenshot = getScreenshot(slug, darkModeEnabled ? "dark" : "light", dashboard.updated_at)

  return (
    <Card showHoverEffect className="rounded-2xl">
      <Link
        variant="naked"
        key={dashboard.id}
        className="!p-3 w-full h-full flex flex-col !items-start rounded-md lg:rounded-xl"
        aria-label={`Open ${dashboard.name}`}
        to={`/dashboard/${slug}`}
      >
        <div className="relative h-44 w-full rounded-lg overflow-hidden">
          {darkModeEnabled !== undefined && (
            <Image
              fill
              src={screenshot}
              alt={dashboard.name}
              style={{ objectFit: "cover" }}
              placeholder="blur"
              blurDataURL={darkModeEnabled ? rgbDataURL(39, 49, 62) : rgbDataURL(243, 244, 246)}
            />
          )}
          <div className="absolute inset-0 bg-gradient-to-br from-purple-600 to-transparent opacity-30 border border-gray-300/50 rounded-lg" />
        </div>
        <div className="pt-4 px-2 pb-1">
          <h2 className="truncate">
            <span className="text-gray-900 dark:text-gray-200">{dashboard.name}</span>
          </h2>
          <div className="flex items-center gap-3 mt-2">
            <UserAvatar avatar_url={dashboard.owner_avatar} alt={dashboard.owner_name} />
            <div className="truncate max-w-[150px]">{dashboard.owner_name}</div>
            {publicDashboardUser?.isPro && <Badge>PRO</Badge>}
          </div>
        </div>
      </Link>
    </Card>
  )
}
